module.exports = __webpack_public_path__ + "static/erik-meijer-8e4f3a2cd2c3db477236f639d36f5e21.jpg";